"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserGroups = exports.getCurrentUser = exports.AuthenticationError = void 0;
const cognito = __importStar(require("amazon-cognito-identity-js"));
class AuthenticationError extends Error {
    constructor({ message, context }) {
        super(message);
        this.context = context;
    }
}
exports.AuthenticationError = AuthenticationError;
const getCurrentUser = (userPool) => __awaiter(void 0, void 0, void 0, function* () {
    const user = userPool.getCurrentUser();
    if (!user)
        throw new AuthenticationError({ message: 'No user currently logged in' });
    const session = yield getSession(user);
    if (!session || !session.isValid())
        throw new AuthenticationError({
            message: 'Current user is not authenticated',
            context: { user: user.getUsername() }
        });
    user.setSignInUserSession(session);
    return user;
});
exports.getCurrentUser = getCurrentUser;
const getSession = (user) => {
    return new Promise((res, rej) => {
        user.getSession((err, session) => {
            const sess = user.getSignInUserSession();
            if (err || !sess) {
                rej(err);
            }
            else {
                res(sess);
            }
        });
    });
};
var UserGroups;
(function (UserGroups) {
    UserGroups["ADMIN"] = "travelnest-internal";
})(UserGroups = exports.UserGroups || (exports.UserGroups = {}));
const getUserGroups = (user) => __awaiter(void 0, void 0, void 0, function* () {
    const session = user.getSignInUserSession();
    const payload = session ? session.getAccessToken().decodePayload() : {};
    return (payload['cognito:groups'] || []);
});
const authenticationApiFactory = () => {
    const USER_POOL_ID = process.env.COGNITO_USER_POOL_ID || 'COGNITO_USER_POOL_ID_ENV_UNSET_ERROR';
    const CLIENT_ID = process.env.COGNITO_CLIENT_ID || 'COGNITO_CLIENT_ID_ENV_UNSET_ERROR';
    const userPool = new cognito.CognitoUserPool({
        UserPoolId: USER_POOL_ID,
        ClientId: CLIENT_ID
    });
    return {
        getCurrentUser: () => (0, exports.getCurrentUser)(userPool),
        getUserGroups
    };
};
exports.default = authenticationApiFactory;
//# sourceMappingURL=authentication.js.map